/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */

export enum Department {
  Building= 1,
  Scaffolding= 2,
  WeatherProtection= 3,
  Elevator= 6,

}